import * as React from 'react';
import {
  Collapse,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  useTheme,
} from '@mui/material';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';

type MenuItemProps = {
  title: string;
  openedMenu?: string;
  isGroup?: boolean;
  link?: string;
  icon?: JSX.Element;
  color?: string;
  children?: JSX.Element;
  onClick?: (route: string | undefined) => void;
  onChangeMenu?: (name: string) => void;
};

export const MenuItem: React.FC<MenuItemProps> = ({
  icon,
  title,
  isGroup = false,
  children,
  link,
  color,
  onClick,
  openedMenu,
  onChangeMenu,
}) => {
  const theme = useTheme();

  const isOpenMenu = openedMenu === title;

  const handleClick = () => {
    if (isGroup) {
      onChangeMenu?.(isOpenMenu ? '' : title);
    } else onClick?.(link);
  };

  return (
    <React.Fragment>
      <ListItem sx={{ padding: 0, paddingX: 1 }}>
        <ListItemButton
          onClick={handleClick}
          sx={{
            bgcolor: isOpenMenu
              ? theme.palette['Ambient/Grayscale/Gray-50']
              : 'transparent',
          }}
        >
          {icon && <ListItemIcon>{icon}</ListItemIcon>}
          <ListItemText
            sx={{ marginLeft: icon ? theme.spacing(-2) : 0 }}
            primary={
              <Typography
                variant="Headlines/Medium"
                color={color ?? 'Ambient/Base/Black'}
              >
                {title}
              </Typography>
            }
          />
          {isGroup ? (
            isOpenMenu ? (
              <ChevronLeft
                sx={{
                  rotate: '-90deg',
                  color: 'Brand/Solid/Primary',
                }}
              />
            ) : (
              <ChevronRight sx={{ color: 'Ambient/Neutrals/Table-Head-BG' }} />
            )
          ) : null}
        </ListItemButton>
      </ListItem>

      {isGroup && (
        <Collapse in={isOpenMenu} timeout="auto" unmountOnExit>
          <List component="nav">{children}</List>
        </Collapse>
      )}
    </React.Fragment>
  );
};

export default MenuItem;
